"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dontShowCMSStarterBundleSelector = exports.hasSameDiscountSelector = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/RequestStatusTypes"));

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _PurchaseMotionSelectors = require("pricing-pages-unified-ui/selectors/PurchaseMotionSelectors");

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _PurchaseMotionsLocations = require("pricing-pages-unified-ui/constants/PurchaseMotionsLocations");

var _PurchaseMotionTypes = require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var hasSameDiscountSelector = function hasSameDiscountSelector(state, firstMerchandiseId, secondMerchandiseId) {
  var firstPromotionEligibility = (0, _PromotionSelectors.merchSpecficPromotionEligibilitySelector)(state, firstMerchandiseId);
  var secondPromotionEligibility = (0, _PromotionSelectors.merchSpecficPromotionEligibilitySelector)(state, secondMerchandiseId);
  return firstPromotionEligibility.monthlyDiscount === secondPromotionEligibility.monthlyDiscount;
};

exports.hasSameDiscountSelector = hasSameDiscountSelector;

var isCMSActivatedUserSelector = function isCMSActivatedUserSelector(state) {
  var purchaseMotionRequestStatus = state.purchaseMotionRequestStatus;
  var purchaseMotionsReady = purchaseMotionRequestStatus === _RequestStatusTypes.default.SUCCEEDED; // default to true if purchase motions are not ready

  if (!purchaseMotionsReady) {
    return true;
  }

  var cmsPurchaseMotions = (0, _PurchaseMotionSelectors.purchaseMotionsSelector)(state, _PurchaseMotionsLocations.EXTENDED_MERCH_CARD, _MerchandiseIds.PRODUCT_CMS_PROFESSIONAL);
  return cmsPurchaseMotions.length === 1 && cmsPurchaseMotions[0] === _PurchaseMotionTypes.BUY_TOUCHLESS;
};

var dontShowCMSStarterBundleSelector = function dontShowCMSStarterBundleSelector(state) {
  // to be eligible you CANNOT be a CMS customer
  var ownsCMSProOrHigher = (0, _ProductOwnershipSelectors.ownsProductOrHigherSelector)(state, _MerchandiseIds.PRODUCT_CMS_PROFESSIONAL); // additionally hide card if user owns marketing pro or higher

  var ownsMarketingProOrHigher = (0, _ProductOwnershipSelectors.ownsProductOrHigherSelector)(state, _MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL); // Need to hide the card in the special edge case where user is both activated
  // (receives only buy now purchase motion for cms) AND there are different
  // discounts between marketing starter + cms. (an example of this scenario is
  // an activated user eligible for the latam-es promotion)

  var activatedUserWithDifferentDiscounts = isCMSActivatedUserSelector(state) && !hasSameDiscountSelector(state, _MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019, _MerchandiseIds.PRODUCT_CMS_PROFESSIONAL);
  return ownsCMSProOrHigher || ownsMarketingProOrHigher || activatedUserWithDifferentDiscounts;
};

exports.dontShowCMSStarterBundleSelector = dontShowCMSStarterBundleSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/CMSStarterBundleSelectors.js
// module id = 360
// module chunks = 5 6 7